import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import $ from "jquery";
import "formBuilder";
import "formBuilder/dist/form-render.min.js";
import AddCommentSection from "../components/common/FormCommentSection/AddCommentSection";
import SubFormCommentsSection from "../components/common/FormApproveComponents/SubFormComments/SubFormCommentsSection";


export const useFormRenderer = () => {
  const formRefs = useRef([]);

  // Add useEffect to inject custom form styles
  React.useEffect(() => {
    if (!document.getElementById('custom-formrender-style')) {
      const style = document.createElement('style');
      style.id = 'custom-formrender-style';
      style.innerHTML = `
        .form-group {
          position: relative;
          display: flex;
          align-items: center;
          margin-bottom: 0;
          padding: 12px 0 20px 0;
        }
        .form-group label {
          min-width: 150px;
          margin-bottom: 0;
          margin-right: 8px;
          font-weight: 600;
          color: #6E6E6E;
          font-family: "Proxima Nova" !important;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 1px;
          text-align: center;
          vertical-align: middle;
          display: flex;
          align-items: center;
        }
        /* Only add colon for non-checkbox/radio labels */
        .form-group label:not([for*='checkbox']):not([for*='radio']):after {
          content: ':';
          margin-left: 4px;
        }
        /* Style checkbox and radio labels as well */
        .form-group .checkbox label,
        .form-group .radio label,
        .form-group input[type='checkbox'] + label,
        .form-group input[type='radio'] + label {
          color: #000000 !important;
          font-family: "Proxima Nova" !important;
          font-weight: 400 !important;
          font-size: 16px !important;
          letter-spacing: 0px !important;
          line-height: 24px !important;
          text-align: center !important;
          vertical-align: middle !important;
        }
        .form-group .form-control, .form-group input, .form-group select, .form-group textarea {
          flex: 1;
          margin-bottom: 0;
          min-width: 0;
          border: 1px solid #D9D9D9 !important;
        }
        .form-group:last-child {
          border-bottom: none;
        }
        /* Remove the default required asterisk from formRender labels */
        .form-group label .fb-required {
          display: inline !important;
          color: red !important;
        }
        .rendered-form .form-control{
          height: 38px
        }
        
        /* === AUTOCOMPLETE FIXES === */
        
        /* Hide the secondary autocomplete input as it do gray line */
        .fb-autocomplete.form-group input.form-control:not([id$="-input"]) {
          display: none !important;
        }
        
        /* Remove bottom border from autocomplete dropdown */
        .fb-autocomplete-list {
          border-bottom: none !important;
        }
        
        /* === COMMENTS SECTION STYLING === */
        
        /* Ensure comments section styling is not overridden by form styles */
        .form-comment-section {
          font-family: "Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          line-height: 1.5 !important;
          color: #333 !important;
        }
        
        /* Reset any form styling that might affect comments titles */
        .form-comment-section h1,
        .form-comment-section h2,
        .form-comment-section h3,
        .form-comment-section h4,
        .form-comment-section h5,
        .form-comment-section h6 {
          font-family: "Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-weight: 500 !important;
          color: #333 !important;
          margin: 0 !important;
          padding: 0 !important;
          border: none !important;
          background: none !important;
          text-transform: none !important;
        }
        
        /* Specific styling for comments titles */
        .form-comment-section [role="heading"],
        .form-comment-section h2 {
          font-size: 1.25rem !important;
          margin-bottom: 24px !important;
          padding-bottom: 8px !important;
          border-bottom: 1px solid #e0e0e0 !important;
        }
        
        /* Button styling protection for Add Comment section */
        .form-comment-section button {
          font-family: "Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: 1.5 !important;
          border-radius: 4px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          text-decoration: none !important;
          text-transform: none !important;
          outline: none !important;
          box-sizing: border-box !important;
        }
        
        /* Primary button styling (Add Comment button) */
        .form-comment-section button[class*="contained"],
        .form-comment-section button[class*="primary"] {
          background-color: #0557D5 !important;
          color: white !important;
          border: 1px solid #0557D5 !important;
          padding: 8px 16px !important;
        }
        
        .form-comment-section button[class*="contained"]:hover,
        .form-comment-section button[class*="primary"]:hover {
          background-color: #0445B8 !important;
          border-color: #0445B8 !important;
        }
        
        /* Secondary/Outlined button styling (Cancel button) - Blue theme */
        .form-comment-section button[class*="outlined"],
        .form-comment-section button[class*="secondary"] {
          background-color: transparent !important;
          color: #0557D5 !important;
          border: 1px solid #0557D5 !important;
          padding: 8px 16px !important;
        }
        
        .form-comment-section button[class*="outlined"]:hover,
        .form-comment-section button[class*="secondary"]:hover {
          background-color: rgba(5, 87, 213, 0.04) !important;
          border-color: #0445B8 !important;
          color: #0445B8 !important;
        }
        
        /* Text button styling - Blue theme */
        .form-comment-section button[class*="text"] {
          background-color: transparent !important;
          color: #0557D5 !important;
          border: none !important;
          padding: 8px 16px !important;
        }
        
        .form-comment-section button[class*="text"]:hover {
          background-color: rgba(5, 87, 213, 0.04) !important;
          color: #0445B8 !important;
        }
        
        /* Disabled button styling */
        .form-comment-section button:disabled {
          opacity: 0.5 !important;
          cursor: not-allowed !important;
          pointer-events: none !important;
        }
        
        /* Input field styling protection */
        .form-comment-section input,
        .form-comment-section textarea {
          font-family: "Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          line-height: 1.5 !important;
          color: #333 !important;
          background-color: white !important;
          border: 1px solid #d9d9d9 !important;
          border-radius: 4px !important;
          padding: 8px 12px !important;
          outline: none !important;
          box-sizing: border-box !important;
        }
        
        .form-comment-section input:focus,
        .form-comment-section textarea:focus {
          border-color: #0557D5 !important;
          box-shadow: 0 0 0 2px rgba(5, 87, 213, 0.1) !important;
        }

      `;
      document.head.appendChild(style);
    }
  }, []);

  const renderForm = ({
    form,          
    container,     
    filledForm,    
    handleAddComment,
    requestProgressId,
    persona,
    requestId,
    enableAddComment = true,
    showCommentsTitle = false,
    children,
    requestProgress,
    disabled = true,
    currentStageStatus,
  }) => {
    if (!form || !container || !filledForm) return;
    console.log("renderForm", requestId, requestProgressId);
    // if approved disable add comment
    if (currentStageStatus?.status === "approved") {
      enableAddComment = false;
    }

    // Parse form data
    let parsedFormData;
    try {
      parsedFormData = typeof filledForm === 'string' 
        ? JSON.parse(filledForm) 
        : filledForm?.value 
          ? JSON.parse(filledForm.value) 
          : filledForm;
    } catch (e) {
      console.error('Error parsing form data:', e);
      return;
    }

    if (!parsedFormData) return;

    const data = parsedFormData[form.id];

    // Clear container first
    container.innerHTML = '';
    
    if (!data) {
      container.innerHTML = '<p>No data available for this form.</p>';
      return;
    }
    
    // Parse form schema to see field structure
    let formFields;
    try {
      formFields = JSON.parse(form["json_object"]);
    } catch (e) {
      console.error('useFormRenderer - Error parsing form schema:', e);
      return;
    }
    
    // Render the form
    const formDataWithValues = formFields.map((obj) => {
      const fieldValue = data[obj.name];      
      return { ...obj, value: fieldValue, disabled: disabled };
    });
        
    $(container).formRender({
      dataType: "json",
      formData: formDataWithValues,
    });
        
    // Add comments section
    const actionContainer = document.createElement("div");
    actionContainer.className = "form-comment-section";
    actionContainer.style.marginTop = "35px";
    container.appendChild(actionContainer);

    ReactDOM.render(
      <div style={{ 
        isolation: 'isolate', 
        position: 'relative',
        zIndex: 1
      }}>
        {enableAddComment ? (
          <AddCommentSection
            formData={form}
            handleAddComment={handleAddComment}
            requestProgressId={requestProgressId}
            persona={persona}
            requestId={requestId}
          />
        ) : requestId && requestProgressId && (
          <div style={{
            fontFamily: 'inherit',
            fontSize: 'inherit', 
            lineHeight: 'inherit',
            color: 'inherit'
          }}>
            <SubFormCommentsSection
              persona={persona}
              requestId={requestId}
              subFormId={form.id}
              requestProgressId={requestProgressId}
            />
          </div>
        )}
      </div>,
      actionContainer
    );
  };

  return {
    formRefs,
    renderForm, 
  };
}; 